import {Box, Grid, Typography} from '@mui/material';
import {AppBoardViews} from 'views/board/BoardViews';
import {SprintsDropDownMenu} from 'views/board/sprints';
import {AppIconButton} from 'components/buttons';
import {AppInput} from 'components/form';
import {AppTooltip} from 'components/toolip';
import {FeautureGuard} from 'guards';
import {useBoardRedux, useDebounceEffect} from 'hooks';
import {Refresh} from 'iconsax-react';
import {defaultTo} from 'lodash';
import {TenantSettingsKeysEnum} from 'models/settings';
import {useItemDataState} from 'providers';
import {useEffect, useState} from 'react';
import {Outlet} from 'react-router-dom';
import {BoardSetting} from 'views/settings';
import {BOARD_HEADER_HEIGHT} from 'configs';

export const BoardIndex = () => {
    const {clearBoardItemData} = useItemDataState();
    const {setBoardSearchValue, selectedBoard} = useBoardRedux();
    const [boardRefreshState, setBoardRefreshState] = useState<number>(0);
    const [search, setSearch] = useState<string | undefined>();
    const handleRefreshBoard = (): void => {
        setBoardRefreshState(prev => prev + 1);
    };

    useEffect(() => {
        return () => {
            setBoardSearchValue();
        };
    }, []);

    useDebounceEffect(
        () => {
            if (search !== undefined) {
                clearBoardItemData();
                setBoardSearchValue(search);
            }
        },
        [search],
        1000,
    );
    const searchChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    };
    return (
        <>
            {/* do not remove this outlet 
         it's rendering the sub routes of the board which is item data index 
         item data index is responsiable for opeing the item data dioalog 
        */}
            <Outlet />
            <Box height={'100%'} width={'100%'} sx={{overflow: 'hidden'}}>
                <Grid
                    container
                    justifyContent="space-between"
                    alignItems="flex-end"
                    spacing={1}
                    sx={{height: BOARD_HEADER_HEIGHT}}
                >
                    <Grid item display={'flex'} sm={9} xs={12} alignItems="center">
                        <Typography ml={3} variant="h5">
                            {defaultTo(selectedBoard?.title, '')}
                        </Typography>

                        <AppTooltip title="Refresh Board">
                            <AppIconButton sx={{ml: 0.5}} size="small" onClick={handleRefreshBoard}>
                                <Refresh size={1} />
                            </AppIconButton>
                        </AppTooltip>
                        <BoardSetting />
                        <AppInput placeholder="Search" onChange={searchChangeHandler} />
                        <Box>
                            <AppIconButton></AppIconButton>
                        </Box>
                    </Grid>
                    <Grid item sm={2} xs={12}>
                        <FeautureGuard featuresKeys={[TenantSettingsKeysEnum.TenantEnableSprints.toString()]}>
                            <SprintsDropDownMenu />
                        </FeautureGuard>
                    </Grid>
                </Grid>
                <Box
                    mt={{sm: 0, xs: '50px'}}
                    sx={{overflow: 'auto'}}
                    height={{sm: `calc(100% - ${BOARD_HEADER_HEIGHT})`, xs: 'calc(100% - 90px)'}}
                >
                    <AppBoardViews key={`board-refresh-${boardRefreshState}`} />
                </Box>
            </Box>
        </>
    );
};

export default BoardIndex;
